import React, { Fragment, useState, useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle,  CardBody, CardHeader } from 'reactstrap';
import classnames from 'classnames';
import Documents from './tabcontent/documents';
import Users from './tabcontent/users';
import Details from './tabcontent/details';
import { Link } from 'react-router-dom';
import { ADMIN_AGENCIES_PATH } from '../../../utils/AppRoutes';

const View = (props) => {

  const {
    location :{
      state = { }
    }
  } = props; 
  
  
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

  useEffect(() => {
    if(state.hasOwnProperty('gotoTab'))
    {
      const { gotoTab = '1' } = state;
      setActiveTab((gotoTab).toString());
    }
  }, [])
  return (
      <Fragment>  
        <Card >
        <CardHeader>  
            <CardTitle style={{margin: '0'}}> Agency Details
              <Link to={ADMIN_AGENCIES_PATH}>
                <Button className="f-r" color="primary">
                    <i className="fas fa-arrow-left"></i> Back
                </Button>
            </Link>  
            </CardTitle> 
        </CardHeader>
          <div className="tableTitleBg mb-4">           
            <CardBody>

            <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' },'cursorHand')}
            onClick={() => { toggle('1'); }}
          >
            About Agency
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' },'cursorHand')}
            onClick={() => { toggle('2'); }}
          >
            Documents
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '3' },'cursorHand')}
            onClick={() => { toggle('3'); }}
          >
            Users
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
         <Details />
        </TabPane>
        <TabPane tabId="2">
           <Documents />
        </TabPane>
        <TabPane tabId="3">
       <Users />
        </TabPane>
      </TabContent>
      </CardBody>
      </div>
        </Card>
    </Fragment>
  );
}

export default View;